import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

export type IDialogBoxProps = {
    title?: string,
    content?: string,
}

const useStyles = makeStyles({
    root: {
        fontFamily: "Source Sans Pro",
    },
    closeButton: {
        position: 'absolute',
        right: 1,
        top: 1,
        color: "#707070",
    },
    content: { paddingBottom: 45, fontFamily: "Source Sans Pro", fontWeight: 500, },
    okbutton: {
        borderRadius: 2, backgroundColor: "#006ad2", textTransform: 'none',
        fontWeight: 500, fontFamily: "Source Sans Pro",
        boxShadow: "none",
        '&:hover': {
            backgroundColor: "#006ad2",
            textTransform: 'none',
            boxShadow: "none",
        },
    },
    cancelbutton: {
        borderRadius: 2, backgroundColor: "#ffffff", textTransform: 'none', boxShadow: "none",
        color: "#006ad2",
        fontWeight: 500, fontFamily: "Source Sans Pro",
        border: "1px solid #e0e0e0",
        '&:hover': {
            backgroundColor: "#ffffff",
            textTransform: 'none',
            boxShadow: "none",
            border: "1px solid #e0e0e0",
        },
    },
    title: { fontFamily: "Source Sans Pro", fontWeight: 600 },
    hr:{width:"100%", color:"#707070"}
});

export default function DialogBox(props: { dialogBoxProps: IDialogBoxProps,   
    dispatch: React.Dispatch<any>,
    state: boolean,
    onactionedConfirmed: (val: boolean) => void}) {
    const classes = useStyles();

    const handleClose = () => {
        props.dispatch({ type: "BADGE_STATUS", status: false });
        props.onactionedConfirmed(false);
    };
    const handleConfirm = () => {
        props.dispatch({ type: "BADGE_STATUS", status: false });
        props.onactionedConfirmed(true);
    };

    return (
        <div>
            <Dialog
                open={props.state}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.title} id="alert-dialog-title">{props.dialogBoxProps.title}</DialogTitle>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose} disableRipple>
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <DialogContentText className={classes.content} id="alert-dialog-description">
                        {props.dialogBoxProps.content}
                    </DialogContentText>
                   
                </DialogContent>
                <hr  className={classes.hr}/>
                <DialogActions>
                    <Button variant="outlined" className={classes.cancelbutton} onClick={handleClose} color="primary" autoFocus disableRipple>
                        Cancel
          </Button>
                    <Button variant="contained" className={classes.okbutton} onClick={handleConfirm} color="primary" disableRipple>
                        Confirm
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
